import React, { useEffect, useState } from "react";
//component
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import { useHistory } from "react-router-dom";
import Header from "../../../components/molecules/Header";
import Swiper from "./swiper";
import Leaderboard from "./leaderboard";
import KategoriPopuler from "./kategoriPopuler";
import BrandPopuler from "./brandPopuler";
import KoleksiPilihan from "./koleksiPilihan";
import Banner from "./banner";
import Produk from "./produk";
import FlashSale from "./flashSale";
import TokoramePoint from "./tokoramePoint";
import Gap from "../../../components/Gap";
//material
import useStyles from "./style/style";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Campaigns from "./campaigns";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import TokoramePoinImage from "../../../assets/images/tokoramePoin.png";
import RegisByOrder from "./RegisByOrder";
import RumahZakat from "./RumahZakat";
// import BundlingProduk from "./bundlingProduk";
import DialogPopup from "./dialogPopup";
import NewProduk from "./newProduk";
import { Divider } from "@material-ui/core";
import PreOreder from "./preOrders";
import CollectionProduct from "./collectionProduct";
import CountdownEvent from "./countdownEvent";
import ProductCampaigns from "./ProductCampaigns";
import CounAccumulation from "./counAccumulation";
import ProductBundling from "./ProductBundling";

function AlertVerifikasiKtp({ open, handleClose, verifikasiData }) {
  const history = useHistory();

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography style={{ fontSize: "15px" }}>Verifikasi Akun</Typography>{" "}
      </DialogTitle>
      <DialogContent>
        {verifikasiData === undefined && (
          <Typography style={{ fontSize: "14px" }}>
            👋 Hallo Seller Tangguh, yuk segera verifikasi akun untuk
            memvalidasi data dan memudahkanmu melakukan transaksi.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button size="small" onClick={handleClose} color="secondary">
          Nanti
        </Button>
        <Button
          size="small"
          onClick={() => history.push("/akun/verifikasi")}
          color="primary"
        >
          Verifikasi
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function AlertInpoin({ open, handleClose, inpoinRef }) {
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const getPoint = async () => {
    try {
      setLoading(true);
      const func = firefunctions.httpsCallable("inpoin-runActivity");
      const data = { alias: "REGIS" };
      const res = await func(data);
      if (res?.data?.success === true) {
        inpoinRef.set({ register: true }, { merge: true });
      }
      setLoading(false);
      handleClose();
    } catch (error) {
      if (error) {
        const loginInpoin = async () => {
          try {
            await firefunctions.httpsCallable("inpoin-login")();
          } catch (error) {
            console.log("-loginInpoin", error);
          }
        };
        loginInpoin();
      }
      console.log(error.message);
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.dialogTokoramepoin}
    >
      <DialogContent className={classes.dialogContentTokoramePoin}>
        <div className={classes.wrapDialog}>
          <div>
            <div className={classes.wrapButtonCloseTokoramepoin}>
              <IconButton size="small" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 15,
              }}
            >
              <div
                style={{
                  backgroundImage: `url(${TokoramePoinImage})`,
                  width: "100%",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "auto",
                  backgroundPosition: "center",
                  height: "300px",
                }}
              ></div>
            </div>
          </div>
        </div>
        <div style={{ paddingTop: "5px", paddingBottom: "15px" }}>
          <div style={{ textAlign: "center", padding: "0px 15px" }}>
            <Typography style={{ fontSize: "14px" }}>
              Mulai dan ambil bagian kamu di Tokorame coin dengan mendapatkan
              100 point pertama
            </Typography>
          </div>
          <Gap height={15} />
          <div style={{ padding: "0px 15px" }}>
            <Typography style={{ fontSize: "10px" }} color="textSecondary">
              *Tokorame coin bisa kamu tukarkan dengan berbagai voucher spesial
              yang telah disediakan
            </Typography>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          size="small"
          onClick={getPoint}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} /> : "mulai"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function Katalog() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const [openFlashSale, setOpenFlashSale] = useState(false);

  const [openInpoin, setOpenInpoin] = useState(false);
  const {
    inpoinRef,
    inpoinActivity,
    verifikasiData,
    campaigns,
    global_settings,
    level,
    popups,
    visiblePopups,
    setVisiblePopups,
    countdownList,
  } = useData();

  // console.log(popups,visiblePopups,level?.is_active, !inpoinRef?.register);
  useEffect(() => {
    if (level?.is_active) {
      if (global_settings?.aktivasi_inpoin) {
        if (!inpoinActivity && !inpoinRef?.register) {
          setTimeout(() => setOpenInpoin(true), 3000);
        } else {
          // getPopupsVisible();
          setOpenInpoin(false);
        }
      } else {
        // getPopupsVisible();
      }
    }
  }, []);
  // console.log(visiblePopups);
  const handleVisiblePopup = (props) => {
    setVisiblePopups((data) => ({
      ...data,
      [props]: {
        status: false,
        hidden: true,
      },
    }));
    setVisiblePopups((data) => ({
      ...data,
      [props + 1]: {
        ...data?.[props + 1],
        hidden: false,
      },
    }));
  };

  // useEffect(() => {
  //   if (global_settings.aktivasi_wajib_verifikasi_akun === true) {
  //     if (verifikasiData === undefined) {
  //       setTimeout(() => setOpen(true), 3000);
  //     }
  //   }
  // }, [global_settings.aktivasi_wajib_verifikasi_akun, verifikasiData]);

  return (
    <>
      <Header />
      <Swiper />
      <div className={classes.wrapKatalog}>
        {global_settings?.aktivasi_inpoin && inpoinActivity?.register && (
          <>
            {" "}
            <TokoramePoint />
          </>
        )}
        {global_settings?.aktivasi_register_by_order && !level?.is_active && (
          <>
            <RegisByOrder />
            <Divider
              style={{
                height: 5,
                marginLeft: -10,
                marginRight: -10,
                backgroundColor: "#efefef",
              }}
            />
          </>
        )}
        
        {countdownList.is_active ? <CountdownEvent /> : ""}
        <CounAccumulation />
        <KategoriPopuler />
        <Divider
          style={{
            height: 5,
            marginLeft: -10,
            marginRight: -10,
            backgroundColor: "#efefef",
          }}
        />
        <BrandPopuler />
        <ProductBundling />
        <PreOreder />
        <ProductCampaigns />
        <NewProduk />
        <FlashSale
          openFlashSale={openFlashSale}
          setOpenFlashSale={setOpenFlashSale}
        />
        <Divider
          style={{
            height: 5,
            marginLeft: -10,
            marginRight: -10,
            backgroundColor: "#efefef",
          }}
        />
        <Leaderboard />
        {campaigns?.length > 0 && (
          <>
            <Divider
              style={{
                height: 5,
                marginLeft: -10,
                marginRight: -10,
                backgroundColor: "#efefef",
              }}
            />
            <Campaigns />
          </>
        )}
        {global_settings?.aktivasi_collections && (
          <>
            <Divider
              style={{
                height: 5,
                marginLeft: -10,
                marginRight: -10,
                backgroundColor: "#efefef",
              }}
            />
            <CollectionProduct />
          </>
        )}
        <Divider
          style={{
            height: 5,
            marginLeft: -10,
            marginRight: -10,
            backgroundColor: "#efefef",
          }}
        />
        <RumahZakat />
        <Divider
          style={{
            height: 5,
            marginLeft: -10,
            marginRight: -10,
            backgroundColor: "#efefef",
          }}
        />
        <KoleksiPilihan />
        <Divider
          style={{
            height: 5,
            marginLeft: -10,
            marginRight: -10,
            backgroundColor: "#efefef",
          }}
        />
        <Banner />
        <Gap height={10} />
        <Produk />
      </div>
      <AlertVerifikasiKtp
        open={open}
        handleClose={() => setOpen(false)}
        verifikasiData={verifikasiData}
      />
      <AlertInpoin
        open={openInpoin}
        handleClose={() => setOpenInpoin(false)}
        inpoinRef={inpoinRef}
      />
      {level?.is_active ? (
        <>
          {popups
            ?.sort(
              (a, b) =>
                b?.created_at?.toMillis?.() - a?.created_at?.toMillis?.()
            )
            ?.map((a, b) => {
              if (visiblePopups?.[b]?.hidden) return null;
              return (
                <DialogPopup
                  open={visiblePopups?.[b]?.status}
                  data={a}
                  openFlashSale={openFlashSale}
                  setOpenFlashSale={setOpenFlashSale}
                  handleClose={() => handleVisiblePopup(b)}
                />
              );
            })}
        </>
      ) : null}
    </>
  );
}

export default Katalog;
